/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { SearchFiltersSchema } from './searchFiltersSchema';

export interface CoverageRequestSchema {
  filters?: SearchFiltersSchema;
  pool_ids?: string[] | null;
  search_id?: string | null;
}
